export const MARKETPLACE_DONATE_ROUTE = 'donate';
export const MARKETPLACE_ITEMS_ROUTE = 'pick-another';
